import React from 'react';
import { Redirect, Route } from 'react-router-dom';
import { useAuth } from "../../context/auth";

function PrivateRoute({ component: Component, ...rest }) {
  const { authToken } = useAuth();
  const currentUrl = window.location.href;
  if (!authToken && currentUrl.indexOf("login") < 0) {
    localStorage.setItem("refUrl", currentUrl);
  } else {
    localStorage.removeItem("refUrl");
  }

  return(
    <Route {...rest} render={(props) => (
      !!authToken ? (
        <Component {...props} />
      ) : (
        <Redirect to={`/login`} />
      ))}
    />
  );
}

export default PrivateRoute;